/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Advanced_Options_ButtonInputs */



/**
* | output |
* | --- |
* | "Advanced Options" |
*
* @param {Plain_Text_Import_Advanced_Options_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_advanced_options_button = /** @type {((inputs?: Plain_Text_Import_Advanced_Options_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Advanced_Options_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options avancees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erweiterte Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni avanzate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расширенные параметры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones avanzadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("高级选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("詳細オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन्नत विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções avançadas")
	return /** @type {LocalizedString} */ ("Advanced Options")
});